const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updateLeadTradingAccess = async (leadId, tradingAccessBlocked) => {
    const token = localStorage.getItem('token');

    const response = await fetch(`${API_BASE_URL}/admin/lead/leads/${leadId}/trading-access`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
            trading_access_blocked: Boolean(tradingAccessBlocked),
        }),
    });

    if (!response.ok) {
        const errorData = await response.json();
        console.error('[updateLeadTradingAccess] Error updating lead trading access:', errorData);
        throw errorData;
    }

    return response.json();
};
